var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 0A249.998 249.998 0 0 0 4.804 298.772a250.003 250.003 0 0 0 196.423 196.424 250.003 250.003 0 0 0 256.64-106.304 249.994 249.994 0 0 0 23.103-234.563A250.008 250.008 0 0 0 250 0Zm0 435.029A185.049 185.049 0 0 1 68.511 213.876 185.052 185.052 0 0 1 213.91 68.491 185.047 185.047 0 0 1 435.045 250a184.996 184.996 0 0 1-54.194 130.846A185.015 185.015 0 0 1 250 435.029Z",
    fill: "#7DD03C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.038 394.077c79.551 0 144.039-64.488 144.039-144.039 0-79.55-64.488-144.038-144.039-144.038C168.488 106 104 170.488 104 250.038c0 79.551 64.488 144.039 144.038 144.039Z",
    fill: "#7DD03C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.954 250A185.015 185.015 0 0 0 250 435.029V500a250 250 0 1 1 0-500v64.954A185.013 185.013 0 0 0 64.954 250ZM250 105.949v288.094a144.056 144.056 0 0 0 0-288.094Z",
    fill: "#459D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h500v500H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdg);
export default __webpack_public_path__ + "static/media/odg.2ed25b048840948ad6db15d8bbbf9410.svg";
export { ForwardRef as ReactComponent };